import { render, staticRenderFns } from "./EditMotto.vue?vue&type=template&id=665a1e5d&"
import script from "./EditMotto.vue?vue&type=script&lang=js&"
export * from "./EditMotto.vue?vue&type=script&lang=js&"
import style0 from "./EditMotto.vue?vue&type=style&index=0&id=665a1e5d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports